<template>
  <div
    class="container"
    :class="{ expiredCont: activeName === '3' }"
    v-loading="initDataLoading"
  >
    <div class="block block-noAny" v-if="noAnyServer">
      <div class="title-wrap">
        <div class="title-name"><h2>云服</h2></div>
      </div>
      <div class="content-inner-wrapper">
        <img class="noAnyImg" src="../../images/pc/noAny.svg" />
        <p>购买云服和好朋友一起开启游戏吧～</p>
        <el-button
          @click="
            $router.push({ name: 'cloudServerBuy', params: { type: 'new' } })
          "
          >购买云服</el-button
        >
      </div>
    </div>
    <div class="block" v-else>
      <div class="title-wrap">
        <div class="btn-group title-jump">
          <el-button
            type="primary"
            @click="
              $router.push({ name: 'cloudServerBuy', params: { type: 'new' } })
            "
            round
            >云服购买</el-button
          >
          <el-button
            round
            @click="$router.push({ name: 'cloudServerOrderList' })"
            >购买记录</el-button
          >
        </div>
        <div class="title-name">{{ $route.meta.title }}</div>
      </div>
      <div class="content-inner-wrapper">
        <div class="data-wrap" v-show="isDeveloper">
          <div class="earnings-wrap card">
            <div class="data-item">
              <p class="item-title">本月云服广告播放次数</p>
              <div class="figure-detail">
                <span class="item-figure">{{
                  month_ad_count | format10Thousand
                }}</span>
                <span class="item-wan" v-show="month_ad_count >= UNIT">万</span>
              </div>
              <p class="item-prev">
                昨日 {{ yesterday_ad_count | format10Thousand }}
                <em v-show="yesterday_ad_count >= UNIT">万</em>
              </p>
            </div>
            <i class="data-line"></i>
            <div class="data-item">
              <p class="item-title">本月贡献点收入</p>
              <div class="figure-detail">
                <span class="item-figure">{{
                  month_contribution | format10Thousand(3)
                }}</span>
                <span class="item-wan" v-show="month_contribution >= UNIT"
                  >万</span
                >
              </div>
              <p class="item-prev">
                昨日 {{ yesterday_contribution | format10Thousand(3) }}
                <em v-show="yesterday_contribution >= UNIT">万</em>
              </p>
            </div>
          </div>
          <div class="income-wrap card">
            <div class="data-item">
              <p class="item-title">本月游戏人数</p>
              <div class="figure-detail">
                <span class="item-figure">{{
                  month_player_count | format10Thousand
                }}</span>
                <span class="item-wan" v-show="month_player_count >= UNIT"
                  >万</span
                >
              </div>
              <p class="item-prev">
                昨日 {{ yesterday_player_count | format10Thousand }}
                <em v-show="yesterday_player_count >= UNIT">万</em>
              </p>
            </div>
            <i class="data-line"></i>
            <div class="data-item">
              <p class="item-title">本月游戏时长(分)</p>
              <div class="figure-detail">
                <span class="item-figure">{{
                  month_total_time | format10Thousand
                }}</span>
                <span class="item-wan" v-show="month_total_time >= UNIT"
                  >万</span
                >
              </div>
              <p class="item-prev">
                昨日 {{ yesterday_total_time | format10Thousand }}
                <em v-show="yesterday_total_time >= UNIT">万</em>
              </p>
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <el-link
            class="selectedCount"
            v-show="currServersCount"
            @click="showCurrServs"
            >已选数量：{{ currServersCount }}</el-link
          >
          <el-form
            class="formFloatRight"
            :inline="true"
            v-show="!currServersCount"
          >
            <el-form-item>
              <el-autocomplete
                popper-class="autoPopper"
                @input="handleSearchChange"
                :trigger-on-focus="false"
                value-key="room_name"
                v-model="keyword"
                @select="handleSearchSelect"
                :fetch-suggestions="querySearchAsync"
                placeholder="输入关键字搜索"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item>
              <el-select
                @change="changeSortType"
                v-model="sortType"
                placeholder="排序"
              >
                <el-option label="默认" value="1"></el-option>
                <el-option label="最近到期" value="2"></el-option>
                <el-option label="开启时间" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-tab-pane
            :label="`全部(${allCount})`"
            name="1"
            v-loading="dataLoading"
          >
            <div
              class="data-content"
              :class="{ someoneSelected: !!multipleSelectionAll.length }"
              v-if="allData.length"
            >
              <el-table
                ref="multipleTableAll"
                :data="allData"
                :show-header="false"
                :row-class-name="setRowClassName"
                @selection-change="handleAllSelectionChange"
              >
                <el-table-column
                  type="selection"
                  class-name="myCheckbox"
                  width="55"
                >
                </el-table-column>
                <el-table-column prop="image" label="玩家地图" width="160">
                  <template slot-scope="scope">
                    <img
                      class="playerMap"
                      :src="scope.row.image | setDefaultMapImg"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  class-name="serverInfo"
                  prop="room_name"
                  label="云服信息"
                >
                  <template slot-scope="scope">
                    <h3>{{ scope.row.room_name }}</h3>
                    <p>云服ID：{{ scope.row.id }}</p>
                    <p>云服类型：{{ ROOM_TYPE[scope.row.room_type] }}</p>
                    <p
                      :class="{ 'warn-time': isWarnDay(scope.row.expire_time) }"
                    >
                      剩余时间：{{ scope.row.expire_time | remainderTime }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="serverDetails"
                  label="查看数据"
                  width="120"
                >
                  <template slot-scope="scope">
                    <span
                      @click="serverDetailsClick(scope.row)"
                      class="icon-wrapper"
                      ><i class="icon-server-data"></i>查看数据</span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="serverRenew" label="续费" width="130">
                  <template slot-scope="scope">
                    <el-button
                      @click="renewClick(scope.row)"
                      type="primary"
                      round
                      >续费/升级</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="data-filter-page">
                <el-pagination
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pagination.total"
                  :page-sizes="[10, 50, 100, 200]"
                  :page-size="pagination.page_size"
                  @current-change="allDataPageChange"
                  @size-change="allPageSizeChange"
                >
                </el-pagination>
              </div>
              <transition name="fade">
                <div
                  class="batchRenew batchRenewAll"
                  v-show="multipleSelectionAll.length"
                >
                  <el-checkbox
                    :value="selectAllAll"
                    @change="batchSelectChangeAll"
                    >全选</el-checkbox
                  >
                  <el-button
                    type="primary"
                    class="batchRenewBtn"
                    @click="batchRenew('all')"
                    >批量续费</el-button
                  >
                  <el-button @click="cancelSelectAll">取消</el-button>
                  <el-link @click="showCurrServs"
                    >已选数量：{{ currServersCount }}</el-link
                  >
                </div>
              </transition>
            </div>

            <div class="img-no-data" v-else>
              <img src="../../images/pc/img_map_no_data.png" />
              <p>您暂时还没有数据呢</p>
            </div>
          </el-tab-pane>

          <el-tab-pane
            :label="`生效中(${validCount})`"
            name="2"
            v-loading="dataLoading"
          >
            <div
              class="data-content"
              :class="{ someoneSelected: !!multipleSelectionUsing.length }"
              v-if="serversUsing.length"
            >
              <el-table
                ref="multipleTableUsing"
                :data="serversUsing"
                :show-header="false"
                :row-class-name="setRowClassName"
                @selection-change="handleUsingSelectionChange"
              >
                <el-table-column
                  type="selection"
                  class-name="myCheckbox"
                  width="55"
                >
                </el-table-column>
                <el-table-column prop="image" label="玩家地图" width="160">
                  <template slot-scope="scope">
                    <img
                      class="playerMap"
                      :src="scope.row.image | setDefaultMapImg"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  class-name="serverInfo"
                  prop="room_name"
                  label="云服信息"
                >
                  <template slot-scope="scope">
                    <h3>{{ scope.row.room_name }}</h3>
                    <p>云服ID：{{ scope.row.id }}</p>
                    <p>云服类型：{{ ROOM_TYPE[scope.row.room_type] }}</p>
                    <p
                      :class="{ 'warn-time': isWarnDay(scope.row.expire_time) }"
                    >
                      剩余时间：{{ scope.row.expire_time | remainderTime }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="serverDetails"
                  label="查看数据"
                  width="120"
                >
                  <template slot-scope="scope">
                    <span
                      @click="serverDetailsClick(scope.row)"
                      class="icon-wrapper"
                      ><i class="icon-server-data"></i>查看数据</span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="serverRenew" label="续费" width="130">
                  <template slot-scope="scope">
                    <el-button
                      @click="renewClick(scope.row)"
                      type="primary"
                      round
                      >续费/升级</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="data-filter-page">
                <el-pagination
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="usingPagination.total"
                  :page-sizes="[10, 50, 100, 200]"
                  :page-size="usingPagination.page_size"
                  @current-change="usingDataPageChange"
                  @size-change="usingPageSizeChange"
                >
                </el-pagination>
              </div>
              <transition name="fade">
                <div
                  class="batchRenew batchRenewUsing"
                  v-show="multipleSelectionUsing.length"
                >
                  <el-checkbox
                    :value="selectAllUsing"
                    @change="batchSelectChangeUsing"
                    >全选</el-checkbox
                  >
                  <el-button
                    type="primary"
                    class="batchRenewBtn"
                    @click="batchRenew('using')"
                    >批量续费</el-button
                  >
                  <el-button @click="cancelSelectUsing">取消</el-button>
                  <el-link @click="showCurrServs"
                    >已选数量：{{ currServersCount }}</el-link
                  >
                </div>
              </transition>
            </div>
            <div class="img-no-data" v-else>
              <img src="../../images/pc/img_map_no_data.png" />
              <p>您暂时还没有数据呢</p>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="`已过期(${unvalidCount})`"
            name="3"
            v-loading="dataLoading"
          >
            <div
              class="data-content"
              :class="{ someoneSelected: !!multipleSelectionExpired.length }"
              v-if="serversExpired.length"
            >
              <el-table
                ref="multipleTableExpired"
                :data="serversExpired"
                :show-header="false"
                :row-class-name="setRowClassName"
                @selection-change="handleExpiredSelectionChange"
              >
                <el-table-column
                  type="selection"
                  class-name="myCheckbox"
                  width="55"
                >
                </el-table-column>
                <el-table-column prop="image" label="玩家地图" width="160">
                  <template slot-scope="scope">
                    <img
                      class="playerMap"
                      :src="scope.row.image | setDefaultMapImg"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  class-name="serverInfo"
                  prop="room_name"
                  label="云服信息"
                >
                  <template slot-scope="scope">
                    <h3>{{ scope.row.room_name }}</h3>
                    <p>云服ID：{{ scope.row.id }}</p>
                    <p>云服类型：{{ ROOM_TYPE[scope.row.room_type] }}</p>
                    <p
                      :class="{ 'warn-time': isWarnDay(scope.row.expire_time) }"
                    >
                      剩余时间：{{ scope.row.expire_time | remainderTime }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="serverDetails"
                  label="查看数据"
                  width="120"
                >
                  <template slot-scope="scope">
                    <span
                      @click="serverDetailsClick(scope.row)"
                      class="icon-wrapper"
                      ><i class="icon-server-data"></i>查看数据</span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="serverRenew" label="续费" width="130">
                  <template slot-scope="scope">
                    <el-button
                      @click="renewClick(scope.row)"
                      type="primary"
                      round
                      >续费/升级</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="data-filter-page">
                <el-pagination
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="expiredPagination.total"
                  :page-sizes="[10, 50, 100, 200]"
                  :page-size="expiredPagination.page_size"
                  @current-change="expiredDataPageChange"
                  @size-change="expiredPageSizeChange"
                >
                </el-pagination>
              </div>
              <transition name="fade">
                <div
                  class="batchRenew batchRenewExpired"
                  v-show="multipleSelectionExpired.length"
                >
                  <el-checkbox
                    :value="selectAllExpired"
                    @change="batchSelectChangeExpired"
                    >全选</el-checkbox
                  >
                  <el-button
                    type="primary"
                    class="batchRenewBtn"
                    @click="batchRenew('expired')"
                    >批量续费</el-button
                  >
                  <el-button @click="cancelSelectExpired">取消</el-button>
                  <el-link @click="showCurrServs"
                    >已选数量：{{ currServersCount }}</el-link
                  >
                </div>
              </transition>
            </div>
            <div class="img-no-data" v-else>
              <img src="../../images/pc/img_map_no_data.png" />
              <p>您暂时还没有数据呢</p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="当前云服类型" :visible.sync="dialogTableVisible">
      <el-table
        :data="currServs"
        max-height="400"
        stripe
        border
        :header-cell-style="{ backgroundColor: '#fafafa' }"
      >
        <el-table-column property="id" label="云服ID"></el-table-column>
        <el-table-column property="room_type" label="云服类型">
          <template slot-scope="scope">
            <span>{{ scope.row.room_type | roomType }}</span>
          </template>
        </el-table-column>
        <el-table-column property="stat" label="服务状态">
          <template slot-scope="scope">
            <span>{{ scope.row.stat | getStat }}</span>
          </template>
        </el-table-column>
        <el-table-column property="expire_time" label="剩余时间" width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.expire_time | remainderTime }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import IntersectionObserver from '../../base/IntersectionObserver';
import mixins from '../../mixins/manager.mixins.js';
let $batchRenewAll = document.querySelector('.batchRenewAll');
let $batchRenewUsing = document.querySelector('.batchRenewUsing');
let $batchRenewExpired = document.querySelector('.batchRenewExpired');
let $footers = document.querySelectorAll('.footer');
import { ONE_DAY } from '../../base/CONST';
export default {
  mixins: [mixins],
  data() {
    return {
      currServs: [],
      dialogTableVisible: false,
      ACTIVE_NAME_CAPITALIZE: ['None', 'All', 'Using', 'Expired'],
      keyword: '',
      serversRes: [],
      vid: 1,
    };
  },
  destroyed() {
    IntersectionObserver.unObserve(document.querySelectorAll('.footer'));
  },
  mounted() {
    //云服管理曝光
    this.cloudShow();
    $footers = document.querySelectorAll('.footer');
    $batchRenewAll = document.querySelector('.batchRenewAll');
    $batchRenewExpired = document.querySelector('.batchRenewExpired');
    $batchRenewUsing = document.querySelector('.batchRenewUsing');
    IntersectionObserver.observeEls(
      $footers,
      () => {
        console.log('IntersectionObserver--', this.activeName);
        switch (this.activeName) {
          case '1':
            if (!$batchRenewAll)
              $batchRenewAll = document.querySelector('.batchRenewAll');
            $batchRenewAll && ($batchRenewAll.style.bottom = '-140px');
            $batchRenewAll && ($batchRenewAll.style.position = 'absolute');
            break;
          case '2':
            if (!$batchRenewUsing)
              $batchRenewUsing = document.querySelector('.batchRenewUsing');
            $batchRenewUsing && ($batchRenewUsing.style.bottom = '-140px');
            $batchRenewUsing && ($batchRenewUsing.style.position = 'absolute');
            break;
          case '3':
            if (!$batchRenewExpired)
              $batchRenewExpired = document.querySelector('.batchRenewExpired');
            $batchRenewExpired && ($batchRenewExpired.style.bottom = '-140px');
            $batchRenewExpired &&
              ($batchRenewExpired.style.position = 'absolute');
            break;
        }
      },
      () => {
        switch (this.activeName) {
          case '1':
            $batchRenewAll && ($batchRenewAll.style.bottom = '0');
            $batchRenewAll && ($batchRenewAll.style.position = 'fixed');
            break;
          case '2':
            $batchRenewUsing && ($batchRenewUsing.style.bottom = '0');
            $batchRenewUsing && ($batchRenewUsing.style.position = 'fixed');
            break;
          case '3':
            $batchRenewExpired && ($batchRenewExpired.style.bottom = '0');
            $batchRenewExpired && ($batchRenewExpired.style.position = 'fixed');
            break;
        }
      },
    );
  },
  methods: {
    //云服管理曝光埋点
    cloudShow() {
      this.$log('cloudservice_management_show', 85436, { v7: 1 });
    },
    expiredPageSizeChange(pageSize) {
      this.expiredPagination.page_size = pageSize;
      this.expiredPagination.page = 1;
      this.getAllList(this.expiredPagination);
    },
    usingPageSizeChange(pageSize) {
      this.usingPagination.page_size = pageSize;
      this.usingPagination.page = 1;
      this.getAllList(this.usingPagination);
    },
    allPageSizeChange(pageSize) {
      this.pagination.page_size = pageSize;
      this.pagination.page = 1;
      this.getAllList(this.pagination);
    },
    showCurrServs() {
      switch (this.activeName) {
        case '1':
          this.currServs = this.multipleSelectionAll;
          break;
        case '2':
          this.currServs = this.multipleSelectionUsing;
          break;
        case '3':
          this.currServs = this.multipleSelectionExpired;
          break;
      }
      this.dialogTableVisible = true;
    },
    handleSearchSelect(item) {
      console.log('handleSearchSelect---', item);
    },
    cancelSelectAll() {
      this.$refs.multipleTableAll.clearSelection();
    },
    cancelSelectExpired() {
      this.$refs.multipleTableExpired.clearSelection();
    },
    cancelSelectUsing() {
      this.$refs.multipleTableUsing.clearSelection();
    },
    batchSelectChangeExpired(all) {
      this.$refs.multipleTableExpired.clearSelection();
      if (all) {
        this.serversExpired.forEach(row => {
          this.$refs.multipleTableExpired.toggleRowSelection(row);
        });
      }
    },
    batchSelectChangeUsing(all) {
      this.$refs.multipleTableUsing.clearSelection();
      if (all) {
        this.serversUsing.forEach(row => {
          this.$refs.multipleTableUsing.toggleRowSelection(row);
        });
      }
    },
    batchSelectChangeAll(all) {
      this.$refs.multipleTableAll.clearSelection();
      if (all) {
        this.allData.forEach(row => {
          this.$refs.multipleTableAll.toggleRowSelection(row);
        });
      }
    },
    setRowClassName({ row }) {
      return row.expired ? 'serverRow expired' : 'serverRow';
    },
    serverDetailsClick(row) {
      this.$router.push({
        name: 'cloudServerData',
        params: { currServ: JSON.stringify(row) },
      });
    },
    renewClick(row) {
      const currServers = [row];
      localStorage.setItem('renewItems', JSON.stringify(currServers));
      this.$router.push({
        name: 'cloudServerBuy',
        params: { currServers, type: 'renew' },
      });
      //续费升级埋点
      this.reneUpgradeClick(row);
    },
    //续费升级点击埋点
    reneUpgradeClick(row) {
      let expiredTime = row.expire_time;
      if (('' + expiredTime).length < 13) expiredTime *= 1000;
      const _remainderTime = expiredTime - Date.now();
      let remainderDay = Math.round(_remainderTime / ONE_DAY);
      remainderDay = remainderDay <= 0 ? 0 : remainderDay;
      if (remainderDay > 0) this.vid = 1;
      else this.vid = 2;
      this.$log('renewal_upgrade_click', 85437, { v7: 1, v8: this.vid });
    },
  },
  watch: {
    activeName: function (val) {
      this.currServersCount =
        this[`multipleSelection${this.ACTIVE_NAME_CAPITALIZE[val]}`].length;
    },
  },
};
</script>
<style src="../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
$--color-primary: #fd9b21;
.container {
  padding-bottom: 52px !important;
}
.content-wrapper {
  padding: 0;
}
.block-noAny {
  margin-bottom: 0 !important;
  .title-wrap {
    border-bottom: none !important;
  }
  .content-inner-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .noAnyImg {
    display: block;
    width: 300px;
    height: 219px;
    margin: 70px auto 0;
  }
  p {
    width: 288px;
    height: 26px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 26px;
    text-align: center;
    margin: 7px auto 64px;
  }
  .el-button {
    width: 321px;
    height: 54px;
    background: #fecb4e;
    border-radius: 8px;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3d3c3c;
    line-height: 20px;
    margin-bottom: 200px;
  }
}
.el-tab-pane {
  min-height: 360px;
}
.el-tabs {
  ::v-deep .el-table {
    position: relative;
    overflow: visible;
    &::before {
      display: none;
    }
    .el-table__body-wrapper {
      overflow: visible;
    }
  }
  ::v-deep .el-table__row {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 1012px;
    height: 120px;
    margin: 12px 6px;
    &::before {
      display: block;
      content: '';
      width: 978px;
      height: 120px;
      border-radius: 8px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.05);
      position: absolute;
      top: 0;
      left: 34px;
    }
    .serverInfo {
      flex: auto;
      .cell {
        flex-direction: column;
        align-items: flex-start;
        h3 {
          font-size: 14px;
          font-weight: 400;
          color: #262626;
          line-height: 20px;
          margin-bottom: 6px;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #878d99;
          line-height: 17px;
          margin-bottom: 4px;
        }
        .warn-time {
          color: #f73535;
          margin-bottom: 0;
        }
      }
    }
    td,
    td .cell {
      display: flex;
      align-content: center;
      align-items: center;
      // justify-content: center;
      border-bottom: none;
      .el-button {
        width: 128px;
        height: 40px;
        font-size: 16px;
        margin: auto 20px;
      }
    }
  }
}
::v-deep .el-tabs__content {
  overflow: visible;
}
.data-wrap {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  .card {
    width: 480px;
    height: 176px;
    background: #fafafa;
    border-radius: 12px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .data-item {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background: #fafafa;
    width: 50%;
    height: 176px;
    padding: 13px 18px;

    .item-title {
      font-size: 16px;
      color: #878d99;
      line-height: 30px;
    }
    .figure-detail {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      align-items: baseline;
      .item-figure {
        color: $--color-primary;
        font-size: 36px;
        line-height: 54px;
      }
      .item-detail {
        color: #2b6ddf;
        cursor: pointer;
      }
      .item-wan {
        color: #545a66;
        font-size: 18px;
        margin-left: 16px;
      }
    }
    .item-prev {
      color: #8c8c8c;
      font-size: 16px;
      line-height: 28px;
    }
  }
  .data-line {
    width: 1px;
    height: 120px;
    background: #d9d9d9;
  }
}
.playerMap {
  width: 160px;
  height: 90px;
  border-radius: 2px;
}
.expired {
  .playerMap {
    filter: grayscale(1);
  }
}
::v-deep .serverRow {
  .myCheckbox {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    visibility: hidden;
  }
  &:hover {
    .myCheckbox {
      visibility: visible;
    }
  }
}
::v-deep .someoneSelected {
  .serverRow {
    .myCheckbox {
      visibility: visible;
    }
  }
}
.data-content {
  position: relative;
  margin-left: -34px;
  ::v-deep .el-table {
    table {
      width: 1024px !important;
      tr {
        padding-left: 34px;
      }
    }
  }
}
.batchRenew {
  position: fixed;
  bottom: 0;
  width: 1057px;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px -1px 7px 1px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 14px;
  margin-left: 1px;
  z-index: 998;
  .el-link {
    color: #2b6ddf;
    margin-left: 20px;
    font-size: 16px;
  }
}
.batchRenewBtn {
  margin-left: 16px;
}
::v-deep .el-tabs__item {
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
}
::v-deep .el-tab-pane {
  // margin-top: 63px;
}
::v-deep .selectedCount {
  position: absolute;
  top: -50px;
  right: 0;
  color: #2b6ddf;
  font-size: 16px;
}
::v-deep .formFloatRight {
  position: absolute;
  top: -63px;
  right: 0;
  .el-form-item:last-child {
    margin-right: 0;
  }
}
::v-deep .el-select {
  width: 108px;
}
.servOptDialog {
  ::v-deep .el-dialog {
    padding: 4px 32px 32px;
    .el-form-item {
      padding: 0 32px;
      margin-bottom: 4px;
      height: auto;
      overflow: hidden;
      .el-form-item__content,
      .el-form-item__label {
        height: 28px;
        line-height: 28px;
      }
      .el-form-item__content {
        height: auto;
        overflow: hidden;
        .el-input,
        .el-texterea {
          height: 40px;
          line-height: 40px;
          margin-bottom: 12px;
        }
      }
    }
    .el-dialog__header {
      padding: 20px 0 0;
    }
    .el-dialog__footer {
      border-top: 1px solid #d8d8d8;
      padding: 28px 18px 0;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style>
.el-popper.autoPopper {
  display: none !important;
}
</style>
